__turbopack_context__.v({
  "root": "TypographyStylesWrapper-module-scss-module__2MnQyG__root",
});
